import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  market_type: {
    name: 'Code type of principal market in which AIF trades',
    isStatic: false
  },
  market_code: {
    name: 'MIC code of principal market in which AIF trades',
    isStatic: false
  },
  aggregated_value: {
    name: 'Aggregated value of principal market in which AIF trades',
    isStatic: false
  }
};

export function PrincipalMarkets({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.PRINCIPAL_MARKETS,
    onChangeFund,
    schema: schema.PRINCIPAL_MARKETS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.PRINCIPAL_MARKETS?.field_names || [],
    order: 114,
    tableName: 'PRINCIPAL_MARKETS',
    columnLables,
    isMultiFunds,
    funds
  });

  return (
    <StyledTables id="reporttables-principal-markets-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'PRINCIPAL_MARKETS'}
          id={`reporttables-principal-markets-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}
